import { Component, OnInit } from '@angular/core';
import { ToastNotificationService } from '../../../servicios/toast-notification.service';
import { nkServices } from '../../../servicios/app.nkservicios.services';
import { AppUtilService } from '../../../servicios/app.util.service';
import { AtributosService } from '../../../servicios/atributos.service';
import { HashKeyServices } from '../../../servicios/app.hashkey.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit {
  cabeza:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  ojo:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  boca:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  brazo:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  pie:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  constructor(
              private toast:ToastNotificationService,
              private servicio:nkServices,
              private util:AppUtilService,
              private atrb:AtributosService,
              private hashkey:HashKeyServices
  ) { }

  async ngOnInit(){
    let val_objeto = await this.hashkey.decrypt(localStorage.getItem('vtr')).split(',');
    this.cabeza = environment.path_storage+val_objeto[0];
    this.ojo = environment.path_storage+val_objeto[1];
    this.boca = environment.path_storage+val_objeto[2];
    this.brazo = environment.path_storage+val_objeto[3];
    this.pie = environment.path_storage+val_objeto[4];
  }
  async ngOnChanges(){
    let val_objeto = await this.hashkey.decrypt(localStorage.getItem('vtr')).split(',');
    this.cabeza = environment.path_storage+val_objeto[0];
    this.ojo = environment.path_storage+val_objeto[1];
    this.boca = environment.path_storage+val_objeto[2];
    this.brazo = environment.path_storage+val_objeto[3];
    this.pie = environment.path_storage+val_objeto[4];
  } 

}
